import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import SiteCopyForm from './SiteCopyForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import style from './styles/style.module.css';


class EditSiteCopyModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            deleteConfirm: false,
            fetching: false,
        };
    }
    submitHandler = ( values ) => {
        this.setState( { fetching: true } );
        this.props.updateSiteCopy( this.props.copy.name, { copy_text: values.copy_text } )
        .then( ( copy ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( copy );
        } );
    }
    toggleDeleteConfirmation = ( state ) => {
        return () => {
            this.setState( { deleteConfirm: state } );
        };
    }
    deleteSiteCopy = () => {
        this.setState( { fetching: true } );
        this.props.deleteSiteCopy( this.props.copy.name )
        .then( () => {
            this.setState( { fetching: false, deleteConfirm: false } );
            this.props.onSubmit && this.props.onSubmit( null );
        } );
    }



    render() {
        const { copy } = this.props;
        return (
            <DLModal title='Edit Site Copy'
            closeHandler={ this.props.closeModal }>
                <div>
                    <SiteCopyForm onSubmit={ this.submitHandler } initialValues={ copy } edit />
                    { this.renderDeleteSection() }
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }

    renderDeleteSection = () => {
        if( this.state.deleteConfirm ) {
            return (
                <div className={style.deleteLink}>
                    <p>ARE YOU SURE YOU WANT TO DELETE THIS COPY?</p>
                    <p>
                        <span className={ style.confirmDelete }
                        onClick={ this.deleteSiteCopy }>
                            DELETE COPY
                        </span>
                        <span className={ style.cancelDelete }
                        onClick={ this.toggleDeleteConfirmation( false ) }>
                            CANCEL
                        </span>
                    </p>
                </div>
            );
        }
        return (
            <div className={style.deleteLink}>
                <span
                onClick={ this.toggleDeleteConfirmation( true ) }>
                    DELETE THIS COPY
                </span>
            </div>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        updateSiteCopy: ( name, data ) => {
            return dAPI.patch( `/admin/dynamicCopy/${ name }`, data );
        },
        deleteSiteCopy: ( name ) => {
            return dAPI.delete( `/admin/dynamicCopy/${ name }` );
        },
    };
};

export default connect( null, mapDispatchToProps )( EditSiteCopyModal );
